import { useNode } from "@craftjs/core";
import React from "react";
import { InnerTabSettings } from "./settings";
import icon from "./icon";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";

export const InnerTab = (props) => {
  const {
    id,
    connectors: { connect, drag },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const { children } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-inner-tab": true,
      [`inner-tab-${id}`]: id,
    },
    blockProps.className,
  );

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      {children}
    </div>
  );
};

// To Avoid Mangling in Production
InnerTab.displayName = "InnerTab";

InnerTab.craft = {
  name: "Inner Tab",
  props: {},
  related: {
    settings: InnerTabSettings,
    icon: icon,
    hideFromToolbox: true,
    isHiddenInPostEditor: true,
  },
  custom: {
    name: "Inner Tab",
    slug: "grigora/inner-tab",
  },
};
